import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { CheckableSettings, FilterExpandSettings } from '@progress/kendo-angular-treeview';
import { State } from '@progress/kendo-data-query/dist/npm/state';
import { LocationService } from 'src/app/admin/location/shared/services/location.service';
import { UserMultiSelectorModel } from 'src/app/shared/models/user-multi-selector.model';
import { LocationUsersDropDownModel } from 'src/app/shared/models/users-drop-down-list.model';
@Component({
  selector: 'user-multi-selector-tree-view',
  templateUrl: './user-multi-selector-tree-view.component.html',
  styleUrls: ['./user-multi-selector-tree-view.component.scss']
})
export class UserMultiSelectorTreeViewComponent implements OnInit, AfterViewInit {
  // get root locations ids as input
  @Input() filterTerm: string = '';

  @Input() expandedKeys: any[] = [];
  // get checked components Tree view unique id0
  @Input() selectedUserId: number = 0;

  @Input() locations: UserMultiSelectorModel[] = [];
  @Input() dispatchStateEvent: boolean = true;
  @Output()
  closeEvent: EventEmitter<LocationUsersDropDownModel> = new EventEmitter<LocationUsersDropDownModel>();

  @Output() onChange: EventEmitter<any> = new EventEmitter();

  public locationSelector: LocationUsersDropDownModel = {
    name: '',
    id: 0,
    locationId: 0,
    isUser: false,
    hasChild: false,
    items: []
  };

  // currently checked Tree view unique id
  @Input()
  public checkedKeys: number[] = [];
  ngOnChanges(changes: SimpleChanges) {
    this.checkDefaultValue(changes.checkedKeys.currentValue, this.locations);
    // You can also use categoryId.previousValue and 
    // categoryId.firstChange for comparing old and new values
  }

  public checkAll: boolean = true;

  // Checking component
  public key = 'id';
  public iterableDiffer: any;

  constructor(private locationService: LocationService,
    private store: Store<State>,
    private cdRef: ChangeDetectorRef) { }

  public ngOnInit(): void {
    this.checkDefaultValue(this.checkedKeys, this.locations);
    this.onChange.emit(this.checkedKeys);
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  public checkDefaultValue(checkedKeys: number[], items?: UserMultiSelectorModel[]) {
    if (!items) return;

    for (const item of items) {
      if (item.id && checkedKeys.includes(item.id)) {
        if (item.isUser) {
          item.isSelected = true;
        } else {
          item.isSelected = false;
        }
      }
      else {
        item.isSelected = false;
      }

      this.checkDefaultValue(checkedKeys, item.items);
    }
  }

  public handleCheck(dataItem: UserMultiSelectorModel) {
    if (!dataItem.isUser) return;

    dataItem.isSelected = !dataItem.isSelected;

    this.handleChildCheck(dataItem.items, dataItem.isSelected);

    this.checkedKeys = [];
    this.checkedKeys = this.getCheckedKeys(this.locations, this.checkedKeys);
    this.onChange.emit(this.checkedKeys);
  }

  public handleChildCheck(childItems?: UserMultiSelectorModel[], isSelected: boolean = false) {
    if (!childItems) return;

    for (const childItem of childItems) {
      if (childItem.isUser) {
        childItem.isSelected = isSelected;
        this.handleChildCheck(childItem.items, isSelected);
      }
    }
  }

  public unCheckAll(items?: UserMultiSelectorModel[]) {
    if (!items) return;

    for (const item of items) {
      if (item.isUser) {
        item.isSelected = false;
      }
      else {
        this.unCheckAll(item.items);
      }
    }
  }

  public getCheckedKeys(items?: UserMultiSelectorModel[], keys: number[] = []): number[] {
    if (!items) return [];

    for (const item of items) {
      if (item.id && item.isSelected) {
        keys.push(item.id);
      }
      keys = this.getCheckedKeys(item.items, keys);
    }
    return keys;
  }

  showClick(dataItem: UserMultiSelectorModel) {

    this.locationSelector = {
      id: dataItem?.id,
      name: dataItem?.name,
      locationId: dataItem?.locationId,
      isUser: dataItem?.isUser,
      hasChild: dataItem?.hasChild
    };
    this.closeEvent.emit(this.locationSelector);
  }

  // check item has children
  public hasChildren(item: LocationUsersDropDownModel) {
    return item.hasChild;
  }

  // fetch childrend data
  public fetchChildren = (item: any) => this.locationService.getHierarchyChildLocations(item.locationId);

  // checking settings
  public get checkableSettings(): CheckableSettings {
    return {
      checkChildren: true,
      checkParents: true,
      enabled: true,
      mode: 'multiple',
      checkOnClick: true,
    };
  }

  public filterExpandSettings: FilterExpandSettings = {
    maxAutoExpandResults: 4,
    expandedOnClear: "unchanged"
  }

  private addExpandListItem(treeItem?: LocationUsersDropDownModel[]) {
    if (!treeItem) {
      return;
    }
    treeItem.forEach(item => {
      this.expandedKeys.push(item.locationId);
      if (item.hasChild) {
        this.addExpandListItem(item.items)
      }
    });
  }
}
